/**
 * Samouczek 'Kupony - jak dodac karte podarunkowa'. Ksztalt danych: patrz KONTRAKT.md
 *
 * Zrzuty: ~/.v3sys-ui-check/sam-kupon-dodaj.js (test.v3system.pl, konto uicheck2).
 * Opis odpowiada temu, co system robi naprawde (AddCouponModal.jsx, CouponsPageSimple.jsx,
 * backend/api/coupons.py): zapis kuponu tworzy od razu dokument KP i wpis KP w Kasa/Bank.
 */
const OBRAZ = (plik, opis) => ({ plik, opis });

// Jeden dzial - dziewiec krokow jednym ciagiem. Dodanie karty to jedna czynnosc,
// nie ma sensu dzielic jej na etapy.
const DZIALY = {
  A: { tytul: 'Sprzedaż karty podarunkowej', opis: 'Od wejścia w zakładkę „Kupony" do wydrukowanego potwierdzenia dla klienta.' },
};

const KUPON_DODAJ = {
  id: 'kupon-dodaj',
  dzialy: DZIALY,
  tytul: 'Kupony — jak dodać kartę podarunkową (kupon)',
  dlaKogo: 'Kasjerzy',
  czas: '3 minuty',
  pdf: '/instrukcje/kupon-dodaj.pdf',
  wstep: 'Klient kupuje kartę podarunkową: płaci np. 100 zł, a Ty zakładasz w systemie kupon z takim saldem. '
    + 'Później obdarowany płaci tą kartą w kasie — przy każdym zakupie saldo maleje, aż do zera. '
    + 'Dodanie kuponu księguje wpłatę w kasie, więc zrób to od razu przy sprzedaży karty, nie później.',
  kroki: [
    {
      n: 1,
      dzial: 'A',
      tytul: 'Wejdź w zakładkę „Kupony"',
      tresc: 'Najedź myszą na pasek z ikonami po lewej stronie — pasek się rozwinie i pokaże nazwy. '
        + 'W grupie „Dokumenty" kliknij „Kupony". Otworzy się strona „Kupony podarunkowe" z listą '
        + 'wszystkich kuponów Twojego sklepu.',
      obraz: OBRAZ('/instrukcje/kupon-dodaj-1-menu.jpg', 'Rozwinięty pasek boczny z zaznaczoną pozycją Kupony'),
    },
    {
      n: 2,
      dzial: 'A',
      tytul: 'Kliknij „Dodaj kupon"',
      tresc: 'Zielony przycisk jest w prawym górnym rogu, obok filtrów „Wszystkie", „Aktywne", „Wykorzystane". '
        + 'Sprawdź, czy pod nagłówkiem widzisz nazwę swojego sklepu — kupon zapisze się w tym sklepie, '
        + 'a wpłata trafi do jego kasy. Jeśli przycisku nie ma, nie masz uprawnienia do zakładania kuponów.',
      obraz: OBRAZ('/instrukcje/kupon-dodaj-2-dodaj.jpg', 'Przycisk Dodaj kupon na stronie kuponów'),
    },
    {
      n: 3,
      dzial: 'A',
      tytul: 'Wpisz wartość karty',
      tresc: 'Otworzy się okno „Dodaj nowy kupon". W polu „Wartość (zł)" wpisz kwotę, którą klient płaci za kartę '
        + '— to będzie saldo kuponu. Szybciej: kliknij jedną z gotowych kwot pod polem (20, 50, 100, 150, 200, 500 zł). '
        + 'Na dole okna, w „Podsumowaniu", od razu widzisz wpisaną kwotę. Bez wartości przycisk zapisu jest wyszarzony.',
      obraz: OBRAZ('/instrukcje/kupon-dodaj-3-wartosc.jpg', 'Pole Wartość i przyciski szybkiego wyboru kwoty'),
    },
    {
      n: 4,
      dzial: 'A',
      tytul: 'Sprawdź datę ważności i wybierz sposób płatności',
      tresc: 'System sam wpisuje „Datę ważności" trzy miesiące od dziś. Jeśli w Twoim sklepie karty są ważne dłużej, '
        + 'popraw datę — musi być późniejsza niż dzisiejsza. W polu „Sposób płatności" zaznacz, jak klient płaci '
        + 'za kartę: „Gotówka", „Karta" albo „BLIK". To ważne, bo wpłata za kupon trafia do kasy i liczy się '
        + 'przy zamknięciu zmiany.',
      obraz: OBRAZ('/instrukcje/kupon-dodaj-4-data-platnosc.jpg', 'Pole Data ważności i lista Sposób płatności'),
    },
    {
      n: 5,
      dzial: 'A',
      tytul: 'Zeskanuj kod z karty fizycznej',
      tresc: 'Kliknij w pole „Kod zewnętrzny (opcjonalny)" i przejedź czytnikiem po kodzie kreskowym karty, '
        + 'którą wręczasz klientowi. Dzięki temu w kasie wystarczy zeskanować kartę — system sam znajdzie kupon. '
        + 'Jeśli pole zostawisz puste, kupon dostanie tylko kod systemowy z potwierdzenia. '
        + '„Numer telefonu" jest nieobowiązkowy — przydaje się, gdy klient zgubi kartę, bo po numerze też da się kupon odszukać.',
      obraz: OBRAZ('/instrukcje/kupon-dodaj-5-kod-karty.jpg', 'Pole Kod zewnętrzny z zeskanowanym kodem karty i pole Numer telefonu'),
    },
    {
      n: 6,
      dzial: 'A',
      tytul: 'Kliknij „Dodaj kupon" i poczekaj na potwierdzenie',
      tresc: 'Przycisk „Dodaj kupon" jest na dole okna. Po zapisie pojawia się zielony komunikat '
        + '„Kupon dodany pomyślnie! Kod: …" z ośmioznakowym kodem nadanym przez system. Okno zamyka się samo '
        + 'po chwili, a lista kuponów odświeża się. W tym momencie system wystawił też dokument KP '
        + '(potwierdzenie wpłaty) i zaksięgował wpłatę w Kasa / Bank.',
      obraz: OBRAZ('/instrukcje/kupon-dodaj-6-zapisany.jpg', 'Komunikat o dodaniu kuponu z kodem systemowym'),
    },
    {
      n: 7,
      dzial: 'A',
      tytul: 'Sprawdź kupon na liście',
      tresc: 'W polu „Szukaj po kodzie kuponu lub numerze telefonu…" zeskanuj kartę albo wpisz kod — na liście '
        + 'zostanie tylko ten kupon. W kolumnie „Wartość" widzisz saldo karty, w kolumnie „Status" zieloną '
        + 'etykietę „Aktywny", a w „Ważność" datę, do której karta działa. Tak samo sprawdzisz kartę później, '
        + 'gdy klient zapyta, ile mu zostało.',
      obraz: OBRAZ('/instrukcje/kupon-dodaj-7-lista.jpg', 'Lista zawężona do nowego kuponu z saldem i statusem Aktywny'),
    },
    {
      n: 8,
      dzial: 'A',
      tytul: 'Otwórz dokument zakupu',
      tresc: 'W wierszu kuponu, po prawej, kliknij „Akcje" i wybierz „Dokument". Otworzy się okno '
        + '„Dokument zakupu kuponu" z potwierdzeniem: numer dokumentu KP, kod kuponu, kod z karty, wartość, '
        + 'data ważności, sposób płatności i telefon klienta. Pod „Akcje" jest też „Historia" — lista wszystkich '
        + 'płatności tą kartą — oraz „Użyj", ale w kasie płaci się kuponem normalnie, przy paragonie.',
      obraz: OBRAZ('/instrukcje/kupon-dodaj-8-akcje.jpg', 'Rozwinięte menu Akcje z pozycją Dokument'),
    },
    {
      n: 9,
      dzial: 'A',
      tytul: 'Wydrukuj potwierdzenie dla klienta',
      tresc: 'Na dole okna masz dwa przyciski. „Drukuj (przeglądarka)" otwiera PDF w nowej karcie — drukujesz go '
        + 'na zwykłej drukarce. „Drukuj (kasa fiskalna)" wysyła krótki wydruk niefiskalny na drukarkę fiskalną '
        + '(numer KP, kod kuponu, wartość, ważność). Klient dostaje kartę i potwierdzenie. '
        + 'Dokument możesz wydrukować ponownie w każdej chwili — tą samą drogą.',
      obraz: OBRAZ('/instrukcje/kupon-dodaj-9-dokument.jpg', 'Okno Dokument zakupu kuponu z przyciskami drukowania'),
    },
  ],
  uwagi: [
    'Wpłata za kartę księguje się w kasie w chwili kliknięcia „Dodaj kupon" — z takim sposobem płatności, jaki wybrałeś. '
      + 'Pomyłka (np. „Gotówka" zamiast „Karta") rozjedzie stan kasy przy zamknięciu zmiany. Sprawdź to pole przed zapisem.',
    'Kuponu nie da się wycofać ani poprawić w tym oknie. Jeśli wpiszesz złą kwotę i zapiszesz, zgłoś to kierownikowi — nie zakładaj drugiego kuponu na tę samą kartę.',
    'Jedna karta fizyczna = jeden aktywny kupon. Jeśli zeskanujesz kartę, na której jest jeszcze saldo, system odmówi '
      + '(„Ta karta ma jeszcze aktywne saldo…"). Karta wraca do obiegu dopiero, gdy saldo spadnie do zera.',
    'Data ważności: lista pokazuje „Aktywny" także przy kuponach, którym minął termin. Zanim powiesz klientowi, że karta działa, '
      + 'spójrz na kolumnę „Ważność" — przeterminowanego kuponu kasa nie przyjmie.',
    'Kupon w tym systemie to zawsze karta wartościowa (saldo w złotych, schodzi przy płatności w kasie metodą „Kupon"). '
      + 'Rabaty procentowe to osobna funkcja — przycisk „Rabaty" w kasie — i nie zakłada się ich tutaj.',
  ],
};

export default KUPON_DODAJ;
